import * as React from 'react'
import styles from './style.module.css';
import IconProvider from '../../../../../design-system/lib/IconProvider';
import { Attach, BUSINESS, calendar_gray, calendar_time_gray, CLOSE, email_icon, hashtag2, INFO_CIRCLE, input, list_gray, PERSON } from '../../../../../assets';
import Typography from '../../../../../design-system/lib/Typography';
import Button from '../../../../../design-system/lib/Button';
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { NewCustomerHandleChange, SetRecentAddress, Set_Passenger_Na_Fa_Ph } from '../../../../../Redux/actions/actionNames';
import { useTranslation } from 'react-i18next';
import { Get_User_Recent_Address, Register_New_Customer } from '../../../../../Redux/actions/actions';
import { Get_Addressbook_list_Api } from '../../../../../helper/api';
import Input from '../../../../../design-system/lib/Input';
import { isBoolean, isEmpty, isNumber } from 'lodash';
import CustomField_Input from '../../../../../CustomFields/Input';
import CustomField_Phone from '../../../../../CustomFields/phone';
import TooltipOnro from '../../../../../design-system/lib/Tooltip';
import CustomField_json from '../../../../../CustomFields/json';
import CustomField_DropDown from '../../../../../CustomFields/DropDown';
import CustomField_Date from '../../../../../CustomFields/Date';
import CustomField_file from '../../../../../CustomFields/file';
import CustomField_MultiLine from '../../../../../CustomFields/multiLine';
import Toggle from '../../../../../design-system/lib/toggle';
import CustomField_DateTime from '../../../../../CustomFields/DateTime';
import Radiobutton from '../../../../../design-system/lib/Radiobutton';
import { checkTimestamp, get_dateFormat, get_lang } from '../../../../../helper/UserData/userdate';
import jalali from "jalali-moment";
import EllipisWithTooltip from '../../../../../design-system/lib/ellipsis-with-tooltip';
import { getDropDownCustomFieldText } from '../edit-customer';




function NewCustomerRegister() {
  const newCustomerIsOpen = useSelector((state) => state.NewOrder.newOrder.newCustomer.open)
  const name = useSelector((state) => state.NewOrder.newOrder.newCustomer.name)
  const family = useSelector((state) => state.NewOrder.newOrder.newCustomer.family)
  const phone = useSelector((state) => state.NewOrder.newOrder.newCustomer.phone)
  const email = useSelector((state) => state.NewOrder.newOrder.newCustomer.email)
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [customField, setCustomField] = React.useState({});

  const [customerId, setCustomerId] = React.useState(null);
  const [error, setError] = React.useState(null);
  const customFieldDefinitions = useSelector((state) => state.SharedData?.settings?.customFieldDefinitions ) || []

  const dispatch = useDispatch();


  function ItemsList(data, currentState, setCurrentState) {
    return (
      <div className={styles.itemsConatiner}>
        {data.map((item) => {
          return <div onClick={() => { setCurrentState(item) }}>
            <Radiobutton size="Small" state={(currentState == item.id || currentState == item.title) ? "checked" : "unchecked"} onClick={() => { }} />
            {item.icon && <img src={item.icon} />}
            <Typography weight={(currentState == item.id || currentState == item.title) ? 'Body_Middle_Bold' : 'Body_Middle_Regular'} textColor={'TextNormal'} text={item.title} className={(currentState == item.id || currentState == item.title) ? styles.dropItemchecked : styles.dropItemUnchecked} />

          </div>
        })}
      </div>
    )
  }

  const closeNewCustomer = () => {
    // dispatch(NewCustomerHandleChange({ key: "name", value: "" }))
    // dispatch(NewCustomerHandleChange({ key: "family", value: "" }))
    // dispatch(NewCustomerHandleChange({ key: "phone", value: "" }))
    // dispatch(NewCustomerHandleChange({ key: "email", value: "" }))

    dispatch(NewCustomerHandleChange({ key: "open", value: false }))
  };


  const handleChange = (key, value) => {
    setError(null)

    dispatch(NewCustomerHandleChange({ key, value }))

  }


  const Emailvalidate = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }



  const registerUser = React.useCallback(() => {
    setLoading(true)

 var formData = new FormData();

  formData.append("phone", phone);
  formData.append("givenName", name);
  formData.append("familyName", family);
  formData.append("email", email);
     

  Object.entries(customField).forEach(([key, value]) => {
     (!isEmpty(value) || isBoolean(value) || isNumber(value)) && formData.append(`customFields[${key}]`, value);
});

    dispatch(Register_New_Customer(dispatch,
    //    {
    //   "phone": phone,
    //   "givenName": name,
    //   "familyName": family,
    //   "email": email ,
    //   "customFields": customField
    // }
    formData
    , (call, error) => {
      setLoading(false)
      setError(error ? error : false)
      setCustomerId(call ? call : null)
      if (call, !error) {
        dispatch(SetRecentAddress([]))

        dispatch(Get_User_Recent_Address(dispatch, call, null))

        // if (person) {
        dispatch(
          Set_Passenger_Na_Fa_Ph({
            name: "type",
            value: "individual",
          })
        );
        dispatch(
          Set_Passenger_Na_Fa_Ph({
            name: "name",
            value: name + " " + family,
          })
        );
        dispatch(
          Set_Passenger_Na_Fa_Ph({
            name: "familyName",
            value: family,
          })
        );

        dispatch(
          Set_Passenger_Na_Fa_Ph({
            name: "givenName",
            value: name,
          })
        );

        dispatch(
          Set_Passenger_Na_Fa_Ph({
            name: "phone",
            value: phone,
          })
        );
        dispatch(
          Set_Passenger_Na_Fa_Ph({
            name: "id",
            value: call
          })
        );

        dispatch(
          Set_Passenger_Na_Fa_Ph({
            name: "email",
            value: email
          })
        );
        dispatch(
          Set_Passenger_Na_Fa_Ph({
            name: "balance",
            value: "0",
          })
        );
        dispatch(
          Set_Passenger_Na_Fa_Ph({
            name: "avatarPhoto",
            value: null,
          })
        );
        closeNewCustomer()

      }
    }))


  }, [name, family, phone, email, error  , customField]);


  React.useEffect(() => {
    try {

      document.addEventListener('closeSliders', () => {
        //
        closeNewCustomer()
        //
      })
      return () => {
        document.removeEventListener("closeSliders", () => {

        });
      };
    } catch (error) {

    }
  }, [])








  if (!newCustomerIsOpen) {
    return null
  }
  let filterdcustomFieldDefinitions = customFieldDefinitions.filter(item =>
    item.entityType === 'customer' || item.entityType === 'individualCustomer'
  );





    function hasCustomFieldError(fieldKey, definitions, customField, t) {
    const field = definitions.find(f => f.key === fieldKey);
    if (!field) return false;

    const value = customField[field.key];
    const config = field.config;

    const isEmptyx =
      value === undefined ||
      value === null ||
      value === "" ||
      (Array.isArray(value) && value.length === 0);

    if (!field.isRequired && isEmptyx) return false;

    if (field.isRequired && isEmptyx) {
      return false
    }

    // TEXT
    if (config.type === "singleLine" || config.type === "multiLine") {
      if (typeof value !== "string") {
        return t("custominvalid");
      }

      if (config.minLength && value.length < config.minLength ) {
        return t("customminLength", { min: config.minLength });
      }

      if (config.maxLength && value.length > config.maxLength) {
        return t("custommaxLength", { max: config.maxLength });
      }

      if (config.pattern && !new RegExp(config.pattern).test(value)) {
        return t("custompattern");
      }
    }

    // EMAIL
    if (config.type === "email") {
      if (!/^\S+@\S+\.\S+$/.test(value)) {
        return t("customemail");
      }
    }

    // PHONE
    if (config.type === "phone") {
      if (value.toString().length < 7) {
        return t("customphone");
      }
    }

    // NUMBER
    if (config.type === "number") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return t("customnumber");
      }

      if (config.min && config.min !== undefined && num < config.min ) {
        return t("customnumberMin", { min: config.min });
      }

      if (config.max && config.max !== undefined && num > config.max ) {
        return t("customnumberMax", { max: config.max });
      }
    }

    // DECIMAL


    if (config.type === "decimalNumber") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return t("customnumber");
      }

      if (config.min && config.min !== undefined && num < config.min ) {
        return t("customnumberMin", { min: config.min });

      }

      if (config.max && config.max !== undefined && num > config.max ) {
        return t("customnumberMax", { max: config.max });
      }

      if (config.precision !== undefined) {
        const decimals = value.toString().split(".")[1];
        if (decimals && decimals.length > config.precision) {
          return t("customdecimalPrecision", { p: config.precision });
        }
      }
    }



    // SELECT
    if (config.type === "select") {
      const allowed = config.choices.map(c => c.key);
      if (!allowed.includes(value)) {
        return t("customselect");
      }
    }

    // FILE
    if (config.type === "file") {

      if (value.url) {

      } else {
        if (!(value instanceof File)) {
          return t("customfileInvalid");
        }

        const sizeMB = value.size / (1024 * 1024);
        if (sizeMB > config.maxSizeMB) {
          return t("customfileSize", { max: config.maxSizeMB });
        }

        if (
          config.allowedTypes?.length &&
          !config.allowedTypes.includes(value.type)
        ) {
          return t("customfileType");
        }
      }

    }

    // DATE
    if (config.type === "date" || config.type === "dateTime") {
      if (isNaN(new Date(value).getTime())) {
        return t("customdate");
      }
    }

    return false;
  }




  function renderCustomField(
    field,
    value,
    onChange
  ) {
    switch (field.config.type) {
      case 'phone':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <EllipisWithTooltip>{field?.label}</EllipisWithTooltip>  {field?.isRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
                {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart:"0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_Phone error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)} value={customField[field.key] || ""} hint={field?.label} inputType="number" style={{ width: "184px", minWidth: "181px", borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} onChange={(e) => {

              setCustomField({ ...customField, [field.key]: e })

            }} />

 
          </div>
        );

      case 'singleLine':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <EllipisWithTooltip>{field?.label}</EllipisWithTooltip>  {field?.isRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
                {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart:"0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_Input  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  defvalue={customField[field.key] || ""} value={customField[field.key] || ""} style={{ width: "184px", minWidth: "181px", borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} config={field.config} icon={input} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              setCustomField({ ...customField, [field.key]: e })


            }} />
 
          </div>
        );
      case 'email':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <EllipisWithTooltip>{field?.label}</EllipisWithTooltip>  {field?.isRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
                {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart:"0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_Input  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  defvalue={customField[field.key] || ""} value={customField[field.key] || ""} style={{ width: "184px", minWidth: "181px", borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} config={field.config} icon={email_icon} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              setCustomField({ ...customField, [field.key]: e })


            }} />
 
          </div>
        );

      case 'number':
      case 'decimalNumber':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <EllipisWithTooltip>{field?.label}</EllipisWithTooltip> {field?.isRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
                {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart:"0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_Input  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  value={customField[field.key] || ""} style={{ width: "184px", minWidth: "181px", borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} config={field.config} icon={hashtag2} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              setCustomField({ ...customField, [field.key]: e })


            }} />
 
          </div>
        );

      case 'multiLine':
        return (
          <div className={styles.OptionsRow} style={{ height: "auto", alignItems: "start" }}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <EllipisWithTooltip>{field?.label}</EllipisWithTooltip> {field?.isRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
                {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart:"0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_MultiLine  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  value={customField[field.key] || ""} style={{ width: "184px", minWidth: "181px", borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} config={field.config} icon={input} hint={field?.label} inputType="text" onChange={(e) => {
              setCustomField({ ...customField, [field.key]: e?.target.value })

            }} />
 
          </div>
        );

      case 'boolean':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}>
              <EllipisWithTooltip>{field?.label}</EllipisWithTooltip> {field?.isRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} 
                 {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart:"0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
              </span>
            <Toggle isActive={customField[field.key] || false} setIsHover={(e) => {
              setCustomField({ ...customField, [field.key]: !(customField[field.key] || false) })
            }} />
          </div>
        );

      case 'select':
        return (

          <div className={styles.OptionsRow}>
            <span style={{ 
              fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}>
              <EllipisWithTooltip>{field?.label}</EllipisWithTooltip>{field?.isRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} 
                 {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart:"0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
              </span>
            <CustomField_DropDown  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  style={{ width: "184px", minWidth: "181px", borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} icon={list_gray}
              ItemsList={ItemsList(field?.config?.choices.map((item) => { return { title: item.label, data: item, id: item.key } }), customField[field.key], (JOJO) => {
                console.log("CustomField_DropDown", JOJO)
                setCustomField({ ...customField, [field.key]: JOJO.id })

              })} textStyle={styles.DropDownTextStyle} size='Small' text={customField[field.key] ? getDropDownCustomFieldText(field?.config?.choices , customField[field.key]) : field?.label} placement={'bottomStart'}
              data={field?.config?.choices} requiredText={t("Required")} onClick={(JOJO) => { }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => {
                setCustomField({ ...customField, [field.key]: null })

              }} />
 
          </div>

        );

      case 'date':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex",
              flexDirection: "row", justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {field?.isRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
                {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart:"0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_Date style={{ width: "184px", minWidth: "181px", borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} icon={calendar_gray}
              textStyle={styles.DropDownTextStyle} size='Small'
              text={customField[field.key] ? jalali(new Date(customField[field.key])).locale(get_lang()).format(` ${get_dateFormat(new Date(customField[field.key]))}`) : field?.label}
              placement={'bottomStart'} requiredText={t("Required")} onChange={(JOJO) => {
                setCustomField({ ...customField, [field.key]: JOJO })


              }}
              isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => { }} />


          </div>
        );

      case 'dateTime':
        return (
          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row",
              justifyContent: "center", alignItems: "center"
            }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}><EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {field?.isRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
                {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart:"0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_DateTime style={{ width: "184px", minWidth: "181px", borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} icon={calendar_time_gray}
              textStyle={styles.DropDownTextStyle} size='Small' text={customField[field.key] ? jalali(new Date(customField[field.key])).locale(get_lang()).format(` ${checkTimestamp(new Date(customField[field.key]))}`) : field?.label}
              placement={'bottomStart'} requiredText={t("Required")}
              onChange={(JOJO) => {
                setCustomField({ ...customField, [field.key]: JOJO })


              }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => { }} />

          </div>

        );

      case 'file':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}><EllipisWithTooltip>{field?.label}</EllipisWithTooltip>
            </span>  {field?.isRequired && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
                {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart:"0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_file  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  style={{ width: "184px", minWidth: "181px", borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : "" }} config={field.config} icon={Attach} inputType={"file"}
              textStyle={styles.DropDownTextStyle} size='Small' text={field?.label} placement={'bottomStart'}
              requiredText={t("Required")} onChange={(JOJO) => {
                setCustomField({ ...customField, [field.key]: JOJO })

              }} isSelected={customField[field.key]} clearText={t("clear")} clearOnClick={() => { }} />

 
          </div>
        );


      default:
        return null;
    }
  }



 function validateRequiredCustomFields(
  filterdcustomFieldDefinitions ,
  customField 
) {

  const errors  = [];

  filterdcustomFieldDefinitions
    .filter(field => field.isRequired)
    .forEach(field => {
      const value = customField[field.key];
      const config = field.config;
      const label = field.label || field.key;

      // null / undefined / empty
      if (value === undefined || value === null || value === "") {
        errors.push(`${label} الزامی است`);
        return;
      }

      // ---------- TEXT ----------
      if (config.type === "singleLine" || config.type === "multiLine") {
        if (typeof value !== "string" || value.trim() === "") {
          errors.push(`${label} نباید خالی باشد`);
          return;
        }

        if (config.minLength && value.length < config.minLength) {
          errors.push(`${label} حداقل ${config.minLength} کاراکتر`);
        }

        if (config.maxLength && value.length > config.maxLength) {
          errors.push(`${label} حداکثر ${config.maxLength} کاراکتر`);
        }

        if (config.pattern && !new RegExp(config.pattern).test(value)) {
          errors.push(`${label} فرمت معتبر نیست`);
        }
      }

      // ---------- EMAIL ----------
      if (config.type === "email") {
        const emailRegex = /^\S+@\S+\.\S+$/;
        if (!emailRegex.test(value)) {
          errors.push(`${label} ایمیل معتبر نیست`);
        }
      }

      // ---------- PHONE ----------
      if (config.type === "phone") {
        if (value.toString().length < 7) {
          errors.push(`${label} معتبر نیست`);
        }
      }

      // ---------- NUMBER ----------
      if (config.type === "number") {
        const num = Number(value);
        if (Number.isNaN(num)) {
          errors.push(`${label} باید عدد باشد`);
          return;
        }

        if (config.min !== undefined && num < config.min) {
          errors.push(`${label} حداقل ${config.min}`);
        }

        if (config.max !== undefined && num > config.max) {
          errors.push(`${label} حداکثر ${config.max}`);
        }
      }

      // ---------- DECIMAL ----------
      if (config.type === "decimalNumber") {
        const num = Number(value);
        if (Number.isNaN(num)) {
          errors.push(`${label} باید عدد باشد`);
          return;
        }

        if (config.min !== undefined && num < config.min) {
          errors.push(`${label} حداقل ${config.min}`);
        }

        if (config.max !== undefined && num > config.max) {
          errors.push(`${label} حداکثر ${config.max}`);
        }

        if (config.precision !== undefined) {
          const decimals = value.toString().split(".")[1];
          if (decimals && decimals.length > config.precision) {
            errors.push(`${label} حداکثر ${config.precision} رقم اعشار`);
          }
        }
      }

      // ---------- SELECT ----------
      if (config.type === "select") {
        const allowed = config.choices.map(c => c.key);
        if (!allowed.includes(value)) {
          errors.push(`${label} انتخاب نامعتبر`);
        }
      }

      // ---------- FILE ----------
      if (config.type === "file") {
        if (!(value instanceof File)) {
          errors.push(`${label} فایل انتخاب نشده`);
          return;
        }

        const sizeMB = value.size / (1024 * 1024);
        if (sizeMB > config.maxSizeMB) {
          errors.push(`${label} حداکثر ${config.maxSizeMB}MB`);
        }

        if (
          config.allowedTypes?.length &&
          !config.allowedTypes.includes(value.type)
        ) {
          errors.push(`${label} نوع فایل مجاز نیست`);
        }
      }

      // ---------- DATE ----------
      if (config.type === "date" || config.type === "dateTime") {
        if (isNaN(new Date(value).getTime())) {
          errors.push(`${label} تاریخ معتبر نیست`);
        }
      }

      // ---------- JSON ----------
      if (config.type === "json") {
        try {
          if (typeof value === "string") JSON.parse(value);
        } catch {
          errors.push(`${label} JSON معتبر نیست`);
        }
      }
    });

  if (errors.length > 0) {
   // setMessage(errors.join("\n"));
    return false;
  }

  return true;
}


let canRegister =  (name?.length > 0 && family?.length > 0) && (phone?.length > 3 && (email?.length > 0 ? Emailvalidate(email) : true) ? isValidPhoneNumber(String(phone).startsWith("+") ? phone : "+ " + phone) : false) && validateRequiredCustomFields(
  filterdcustomFieldDefinitions,
  customField 
);



console.log("customsadsaField ", customField)
 

 
  return (
    <div className={styles.NewCustomerRegisterContainer}>
      <div className={styles.largeHeader}>
        <Button icon={CLOSE} size="Medium" type="Secondary" onClick={closeNewCustomer} style={{ padding: "7px 6px" }} />
        <div className={styles.largeHeaderTitles}>
          <Typography text={t("NewCustomer")} weight="Body_Middle_Bold" className={styles.SmallTitle} style={{ margin: "0", padding: "0" }} />
        </div>
      </div>

      <div className={styles.body}>

        <div className={styles.collapsed}>

          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> {t("Fname")} {name?.length < 1 && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
            <CustomField_Input defvalue={name} style={{ width: "184px", minWidth: "181px" }} icon={input} hint={t("Fname")} inputType={"text"} onChange={(e) => {
              handleChange("name", isEmpty(e) ? "" : e)
            }} />
          </div>

          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> {t("Lname")} {family?.length < 1 && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
            <CustomField_Input  defvalue={family} style={{ width: "184px", minWidth: "181px" }} icon={input} hint={t("Lname")} inputType={"text"} onChange={(e) => {
              handleChange("family", isEmpty(e) ? "" : e)
            }} />
          </div>

          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> {t("Phone")}  {(phone?.length > 3  ? !isValidPhoneNumber(String(phone).startsWith("+") ? phone : "+ " + phone) : true) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}

            </span>
            <CustomField_Phone  value={phone} style={{ width: "184px", minWidth: "181px", borderColor: isValidPhoneNumber(String(phone).startsWith("+") ? phone : "+ " + phone) ? "" : "red"  }} hint={t("Phone")} inputType="number" onChange={(PrePhoneInput) => {
              handleChange("phone", PrePhoneInput)

            }} />
          </div>

          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>  {t("email")}   {false && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}

            </span>
            <CustomField_Input  defvalue={email} style={{ width: "184px", minWidth: "181px", borderColor: (email?.length > 0 ? Emailvalidate(email) : true) ? "" : "red" }} config={{
              "type": "email"
            }} icon={email_icon} hint={t("email")} inputType="text" onChange={(e) => {
              handleChange("email", e)

            }} />
          </div>


         {filterdcustomFieldDefinitions?.length > 0 &&  <div className={styles.titleOptionsRow} >
            <Typography text={t("Custom")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
            <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
          </div>}



          {filterdcustomFieldDefinitions.map(field =>
            renderCustomField(field, "", handleChange)
          )}



        </div>

        {/* <Input error={(email && String(email).length > 0 && !Emailvalidate(email)) && t("Emailisnotcorrect")} type={"text"} value={email} placeHolder={t("EmailOtional")} onChange={(e) => { handleChange("email", e.target.value) }} /> */}
        <Button disabled={!canRegister} isLoading={loading} text={t("Registercustomer")} size="Medium" type="Primary" style={{ maxHeight: "10px", padding: "9px 10px" }} onClick={registerUser} />

        {(error) && <Typography text={error ? error : t("Emailisnotcorrect")} weight="Body_Small_Regular" style={{ marginTop: "4px" }} textColor='Red' />}

      </div>


    </div>
  )
}

export default NewCustomerRegister